import React, { Component } from 'react';
import $ from "jquery";
import Vas from '../../Vas';
import '../../css/CustomerCard.css';
import CustomerData from "./CustomerCard/CustomerData";
import CustomerPaymentData from "./CustomerCard/CustomerPaymentData";
import CustomerDocumentData from "./CustomerCard/CustomerDocumentData";
import CustomerCertificateData from "./CustomerCard/CustomerVerificationData";
import CustomerAdditionalAdresses from "./CustomerCard/CustomerAddressData";
import CustomerContractData from "./CustomerCard/CustomerContractData";


import CustomerRelationDelete from "./CustomerCard/CustomerRelationDelete";

import SideNavigationCustomerCard from '../../custom_controls/SideNavigationCustomerCard';

import { Icon } from 'component-lib';
import { ClosePopUps } from 'utils-lib';
import { CustomerModel, RequestAjaxClass } from 'models-lib';

//VAS-29919: Hier wird geprüft, ob beim Speichern der Kundendaten auf Ja geklickt wurde
var currentView = localStorage.getItem("currentView");

class CustomerCard extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {};
        //VAS-29919: Wenn ja, wird hier der Standardwert (CustomerData) überschrieben
        this.state.CurrentView = currentView == null ? "CustomerData" : currentView;
        this.CustomerId = props.match.params.id;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
    
        this.CustomerModel = new CustomerModel([this],null, this.Request);
        this.state.Name1 = "";
        this.state.Name2 = "";

        //VAS-29919: Hier wird der gespeicherte Wert aus dem localStorage wieder gelöscht, da einmal ausgelesen und nicht wieder verwendet
        localStorage.removeItem("currentView");
    }

    componentDidMount(){
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setAuth(true);
      this.GetCustomer();
      this.LogoClick();
    }

    Update(observer)
    {
      let me = this;
        this.setState({},()=>{
          if(observer === "Customer"){
            me.setState({Name1:me.CustomerModel.Customer.Name1, Name2: me.CustomerModel.Customer.Name2});
          }
        });
    }
    
    GetCustomer(){
      this.CustomerModel.GetCustomerById(this.CustomerId);
     this.setState({});
    }

    openLoader(){
      $("#LoadingIcon").removeClass().addClass('loaderSmall');
    }

    GetCustomerData(){
        return (<CustomerData id={this.CustomerId} reference={this} />);
    }

    GetCustomerPaymentData(){
        return (<CustomerPaymentData
          id={this.CustomerId}
          me={this} />);
    }

    GetCustomerDocumentData(){
        return (<CustomerDocumentData
          id={this.CustomerId}
          me={this} />);
    }

    GetCustomerCertificateData(){
        return (<CustomerCertificateData id={this.CustomerId} />);
    }

    GetCustomerAdditionalAdresses(){
        return (<CustomerAdditionalAdresses id={this.CustomerId} />);
    }

    GetCustomerContractData(){
      return(<CustomerContractData id={this.CustomerId} />);
    }

    GetCustomerRelationDelete(){
      return(<CustomerRelationDelete id={this.CustomerId} />)
    }

    GetView(nameOfView){

        this.DeselectTabs();
        ClosePopUps.close();
        
        switch (nameOfView){
            case "Data":
                this.SelectTab("DataTabLink");
                this.setState({ CurrentView: "CustomerData" });
                break;
            case "Payment":
                this.SelectTab("PaymentTabLink");
                this.setState({ CurrentView: "CustomerPaymentData" });
                break;
            case "Document":
                this.SelectTab("DocumentTabLink");
                this.setState({ CurrentView: "CustomerDocumentData" });
                break;
            case "Certificate":
                this.SelectTab("CertificateTabLink");
                this.setState({ CurrentView: "CustomerCertificateData" });
                break;
            case "AdditionalAdresses":
                this.SelectTab("AddidionalAdressesTabLink");
                this.setState({ CurrentView: "AdditionalAdresses" });
                break;
            case "ContractData":
              this.SelectTab("ContractDataTabLink");
              this.setState({ CurrentView: "ContractData" });
              break;
            case "RelationDelete":
              this.SelectTab("RelationDeleteTabLink");
              this.setState({ CurrentView: "RelationDelete" });
              break;
            default:
                this.SelectTab("DataTabLink");
                this.setState({ CurrentView: "CustomerData" });
        }
    }

    SelectTab(id){
        $("#"+id).removeClass().addClass("activeTab");
    }

    DeselectTabs()
    {
        $("#DataTabLink").removeClass().addClass("tab");
        $("#PaymentTabLink").removeClass().addClass("tab");
        $("#DocumentTabLink").removeClass().addClass("tab");
        $("#CertificateTabLink").removeClass().addClass("tab");
        $("#AddidionalAdressesTabLink").removeClass().addClass("tab");
        $("#ContractDataTabLink").removeClass().addClass("tab");
        $("#RelationDeleteTabLink").removeClass().addClass("tab");
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');

      if(kontrastNumber == "true"){
        $(".loaderSmall, .loaderComponent").attr('style', 'border-top: 5px solid #1d5c87; border-bottom: 5px solid #1d5c87; z-index: 1;');
        
        $('div div div.personalDataForm table.customerCard thead tr th table tbody tr td div#CustomerCardTitle.customerCardTitle').attr('style', 'color: black');

        $('#btoChoose').attr('style', 'background-color: #1d5c87; width: 100px;');
        
      } else {
        $(".loaderSmall, .loaderComponent").attr('style', 'border-top: 5px solid #3393d3; border-bottom: 5px solid #3393d3; z-index: 1;');  
      }
    }

    render()
    {
        let content = "";
        switch (this.state.CurrentView)
        {
            case "CustomerData":
                content = this.GetCustomerData(this.props.Id);
                break;
           case "CustomerPaymentData":
                content = this.GetCustomerPaymentData(this.props.Id);
                break;
            case "CustomerDocumentData":
                content = this.GetCustomerDocumentData(this.props.Id);
                break;
            case "CustomerCertificateData":
                content = this.GetCustomerCertificateData(this.props.Id);
                break;
            case "AdditionalAdresses":
                content = this.GetCustomerAdditionalAdresses(this.props.Id);
                break;
            case "ContractData":
                content = this.GetCustomerContractData(this.CustomerId);
                break;
            case "RelationDelete":
                content = this.GetCustomerRelationDelete(this.CustomerId);
                break;
            default: content = this.GetCustomerData(this.props.Id);
        }
        
        let customer = "";
        let addresses = "";

        if(currentView != null) {
          customer = <tr>
            <td
              id={"DataTabLink"}
              className={"tab"}
              onClick={()=>{ this.GetView("Data");}} >{Vas.Resources.Labels["CustomerData"]}</td>
          </tr>;

          addresses = <tr>
            <td 
              id={"AddidionalAdressesTabLink"}
              className={"activeTab"}
              onClick={()=>{this.GetView("AdditionalAdresses")}}> {Vas.Resources.Labels["AdditionalAddresses"]}
            </td>
          </tr>;
        } else{
          customer = <tr>
            <td
              id={"DataTabLink"}
              className={"activeTab"}
              onClick={()=>{ this.GetView("Data");}} >{Vas.Resources.Labels["CustomerData"]}</td>
          </tr>;

          addresses = <tr>
            <td 
              id={"AddidionalAdressesTabLink"}
              className={"tab"}
              onClick={()=>{this.GetView("AdditionalAdresses")}}> {Vas.Resources.Labels["AdditionalAddresses"]}
            </td>
          </tr>;
        }

        let payments = <tr>
          <td
            id={"PaymentTabLink"}
            className={"tab"}
            onClick={()=>{ this.GetView("Payment");}}>{Vas.Resources.Labels["MethodsOfPayment"]}</td>
        </tr>;

        let documents = <tr>
          <td
            id={"DocumentTabLink"}
            className={"tab"}
            onClick={()=>{ this.GetView("Document");}}>{Vas.Resources.Labels["Documents"]}</td>
        </tr>;

        let verifications = <tr>
          <td
            id={"CertificateTabLink"}
            className={"tab"}
            onClick={()=>{ this.GetView("Certificate");}}>{Vas.Resources.Labels["Verifications"]}</td>
        </tr>;

        let relationDelete = '';

        let contracts = '';

        if(localStorage.getItem('vas_role') === "3"){
          contracts =
          <tr>
            <td
              id={"ContractDataTabLink"}
              className={"tab"}
              onClick={()=>{ this.GetView("ContractData");}}>{Vas.Resources.Labels["Contracts"]}</td>
          </tr>;

          
          relationDelete = <tr>
            <td
              id={"RelationDeleteTabLink"}
              className={"tab"}
              onClick={()=>{ this.GetView("RelationDelete");}}>{Vas.Resources.Labels["CompanyAssignment"]}</td>
          </tr>;

          if(this.CustomerId === localStorage.getItem('vas_customerId')){
            payments= <tr></tr>;
            documents = <tr></tr>;
            verifications = <tr></tr>;
            contracts = <tr></tr>;
            addresses=<tr></tr>;
            relationDelete = <tr></tr>;
          }else{
            payments= '';
            documents = '';
            verifications = '';
            addresses='';
          }
        }
        
        

        return (<div className="personalDataForm" >
          <table className="customerCard">
            <thead>
              <tr>
                <th className={"customerCardLinksHeader"}></th>
                <th className={"customerCardHeader"}></th>
              </tr>

              <tr>
                <th colSpan={2}>
                  <table style={{ width:'100%' }}>
                    <tbody>
                      <tr>
                        <td style={{ verticalAlign: 'middle', width:'100%' }}><img
                          src={"../images/images.png"}
                          style={{ width: 27, float: 'left' }}
                          alt={"customerAvatar"} /><div className={"customerCardTitle"} id={"CustomerCardTitle"}><b> {this.state.Name1 + ", " + this.state.Name2 }</b></div></td>
                        <td style={{ width:'100px' }}><div
                          id={"LoadingIcon"}
                          className={'hide'}></div></td>
                          <td className={"BurgerMenuCustomerCard"}>
                            <Icon
                            Name={"MenuCustomerCard"}
                            Size={36}
                            Color={"black"} />
                            <SideNavigationCustomerCard id={this.CustomerId}/>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={"customerCardLinks"}>
                  <table>
                    <tbody>
                      {customer}
                      {payments}
                      {documents}
                      {verifications}
                      {contracts}
                      {addresses}
                      {relationDelete}
                    </tbody>
                  </table>
                </td>
                <td
                  id={"tabContent"}
                  style={{ verticalAlign: 'top',textAlign:'left' }} >{content}</td>
              </tr>
            </tbody>
          </table>
        </div>
        );
    }
}
export default CustomerCard;
